import { render, staticRenderFns } from "./PayoutMethodPageContainer.vue?vue&type=template&id=48738014&"
import script from "./PayoutMethodPageContainer.vue?vue&type=script&lang=js&"
export * from "./PayoutMethodPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports